import { ProcessType } from '@xeovision/shared';
import { isPotreeEnabled } from './is-potree-enabled';

export function getProcessType(ext: string) {
  const rawExt = ext.toLowerCase();

  switch (rawExt) {
    case 'zip':
      return ProcessType.ZIP_EXTRACT;
    case 'ifc':
      return ProcessType.IFC_XKT;
    case 'step':
      return ProcessType.STEP_XKT;
    case 'stp':
      return ProcessType.STEP_XKT;
    case 'rvt':
      return ProcessType.RVT_XKT;
    case 'rfa':
      return ProcessType.RFA_XKT;
    case 'nwd':
      return ProcessType.NWD_XKT;
    case 'nwc':
      return ProcessType.NWC_XKT;
    case 'las':
    case 'laz':
      return isPotreeEnabled() ? ProcessType.POINTCLOUD_POTREE : ProcessType.CALCULATE_HASH;
    default:
      return ProcessType.CALCULATE_HASH;
  }
}
